import '@angular/compiler';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { initializeSentry } from './app/core/sentry-client';

initializeSentry();

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => {
    try {
      import('@sentry/angular').then(Sentry => {
        if (Sentry) Sentry.captureException(err);
      }).catch(() => console.error(err));
    } catch {
      console.error(err);
    }
  });
